<template>
    <avue-draggable v-if="data.form_type == 0" :index="data.index" :active="data.active" :width="data.width"
        :height="data.height" :left="data.left" :top="data.top" id="draggable" ref="draggable" @focus="handleFocus"
        @blur="handleBlur" @change="change">
        <div ref="rect" style="position: relative; color: black;">
            <div style="display: flex; width: 100%;height: 100%;box-sizing: border-box; border: 1px solid black;"
                :style="{
                    background: colors[data.type]
                }">
                <span style="align-self: center;margin: auto;z-index: 9999;">{{ dic_types[data.type] }}</span>
            </div>
            <div v-if="markLocationVisable" style="
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    font-size: 12px;
                    z-index:99999;
                    text-shadow: 1px 1px 1px white;
                ">
                {{ location }}
            </div>
            <div v-if="markVisable" style="
                    position: absolute;
                    left: 50%;
                    bottom: 0px;
                    transform: translateX(-50%);
                    font-size: 12px;
                    z-index:99999;
                    text-shadow: 1px 1px 1px white;
                ">
                {{ data.width * lengthRate }}mm
            </div>
            <div v-if="markVisable" style="
                    position: absolute;
                    top: 50%;
                    right: 0;
                    transform: translateY(-50%);
                    font-size: 12px;
                    z-index:99999;
                    text-shadow: 1px 1px 1px white;
                ">
                {{ data.height * lengthRate }}mm
            </div>
        </div>
    </avue-draggable>
</template>
<script>
import { colors, dic_types } from "../api/options"
export default {
    components: {},
    name: "border-rect-item",
    props: {
        data: Object,
        markVisable: Boolean,
        lengthRate: Number,
        index: Number,
        boundary: Object,
        markLocationVisable: Boolean
    },
    data: () => {
        return {
            colors: colors,
            location: null,
            dic_types: dic_types,
        };
    },
    mounted() {
        this.updateLocation();
    },
    computed: {
    },
    watch: {
        "data.top": function () {
            this.updateLocation();
        }
    },
    methods: {
        updateLocation() {
            if (this.boundary) {
                let x = (this.data.left - this.boundary.left) * this.lengthRate;
                let y = (this.boundary.top + this.boundary.height - (this.data.top + this.data.height)) * this.lengthRate;
                this.location = `${x},${y}`;
            }
        },
        handleFocus() {
        },
        handleBlur({ width, height, top, left, index }) {
            left = left < 0 ? 0 : left;
            height = height < 0 ? 0 : height;
            top = top < 0 ? 0 : top;
            width = width < 0 ? 0 : width;
            this.$emit('rectChange', this.index, left, top, width, height);
        },
        setActive(act = false) {
            if (this.data.form_type == 0)
                this.$refs.draggable.setActive(act);
        },
        change(...p) {
            console.log(p)

        },
    },
};
</script>
